import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { DrawerPage } from '../drawer/drawer';

/**
 * Generated class for the HomePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-home',
  templateUrl: 'home.html',
})
export class HomePage {

  pages = [
    { title: 'Atlas de Patologia', icon: "globe", showSubmenu: false },
    { title: 'Estudos científicos', icon: "copy", showSubmenu: false },
    { title: 'Solicitação de visita', icon: "briefcase", showSubmenu: false },
    { title: 'Eventos', icon: "calendar", showSubmenu: false },
    { title: 'Produtos', icon: "flask", showSubmenu: false },
    //  { title: 'Dados do representante', icon: "globe", showSubmenu: false, component: RepresentantePage },
    {
      title: 'Eventos adversos', icon: "warning", showSubmenu: false, submenu: [
        { title: 'Farmacovigilância', icon: "medical" },
        { title: 'Cosmetovigilância', icon: "bulb" },
      ]
    },
    { title: 'Dúvidas/Sugestões', icon: "headset", showSubmenu: false }
  ];

  title = "App Médico"

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad HomePage');
  }

  openPage(page, root) {
    if (page.submenu == undefined) {

      let selectedPage = root == undefined ? this.pages.indexOf(page) : root.submenu.indexOf(page)
      this.navCtrl.setRoot(DrawerPage, {
        item_selected: selectedPage,
        root_item: this.pages.indexOf(root)
      })

      this.title = page.title

    } else if (page.icon == "exit") {


    } else {
      page.submenu != undefined

      if (page.showSubmenu == undefined || page.showSubmenu == false)
        page.showSubmenu = true
      else
        page.showSubmenu = false
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts